module.exports = __webpack_public_path__ + "static/img/wear03.15cae0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wear03.png
// module id = HbCK
// module chunks = 1